<template>
  <div class="overlay-border-left"></div>
</template>

<style lang="scss">
.overlay-border-left {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--color-dark);
}
</style>
